import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { ConstructionSite } from '../ConstructionSite/constructionSiteTypes';
import { ConstructionSiteUsageStatistic } from './constructionSiteUsageStatisticTypes';
export function useConstructionSiteUsageStatisticTools() {
  const $ = _c(11);
  const repository = useEntityRepository(EntityName.ConstructionSiteUsageStatistic);
  const {
    getRequiredCurrentUser
  } = useCurrentUser();
  let t0;
  if ($[0] !== getRequiredCurrentUser || $[1] !== repository) {
    t0 = constructionSites => {
      const statistics = repository.getByUserIdAndConstructionSiteIds(getRequiredCurrentUser().id, constructionSites.map(_temp));
      const statisticsByConstructionSiteId = ArrayUtils.key(statistics, _temp2);
      return constructionSites.map(cs_0 => ({
        constructionSite: cs_0,
        statistic: statisticsByConstructionSiteId.get(cs_0.id)
      })).filter(_temp3);
    };
    $[0] = getRequiredCurrentUser;
    $[1] = repository;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getConstructionSitesWithStatistics = t0;
  let t1;
  if ($[3] !== getRequiredCurrentUser || $[4] !== repository) {
    t1 = constructionSite => {
      const userId = getRequiredCurrentUser().id;
      const statistic_0 = repository.getByUserIdAndConstructionSiteId(userId, constructionSite.id);
      if (statistic_0) {
        repository.update({
          ...statistic_0,
          usageCount: statistic_0.usageCount + 1,
          lastUsedDate: new Date().toISOString()
        });
      } else {
        repository.create({
          userId,
          constructionSiteId: constructionSite.id,
          usageCount: 1,
          lastUsedDate: new Date().toISOString()
        });
      }
    };
    $[3] = getRequiredCurrentUser;
    $[4] = repository;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== getConstructionSitesWithStatistics) {
    t2 = constructionsSites => {
      const constructionSitesWithStatistic = getConstructionSitesWithStatistics(constructionsSites).filter(_temp4);
      constructionSitesWithStatistic.sort(_temp5);
      return constructionSitesWithStatistic.map(_temp6);
    };
    $[6] = getConstructionSitesWithStatistics;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = {
      usedConstructionSite: t1,
      getMostUsedConstructionSites: t2
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp6(constructionSiteWithStatistic_1) {
  return constructionSiteWithStatistic_1.constructionSite;
}
function _temp5(a, b) {
  const usageDiff = b.statistic.usageCount - a.statistic.usageCount;
  if (usageDiff !== 0) {
    return usageDiff;
  }
  return a.constructionSite.name.localeCompare(b.constructionSite.name);
}
function _temp4(constructionSiteWithStatistic_0) {
  return constructionSiteWithStatistic_0.statistic.usageCount > 0;
}
function _temp3(constructionSiteWithStatistic) {
  return !!constructionSiteWithStatistic.statistic;
}
function _temp2(statistic) {
  return statistic.constructionSiteId;
}
function _temp(cs) {
  return cs.id;
}
export type ConstructionSiteUsageStatisticTools = {
  usedConstructionSite: (constructionSite: ConstructionSite) => void;
  /**
   * Returns the construction sites which have been used at least once, sorted by the usageCount.
   * If 2 construction sites have the same usage count, they will be sorted by name then
   */
  getMostUsedConstructionSites: (constructionSites: Array<ConstructionSite>) => Array<ConstructionSite>;
};
type ConstructionSiteWithStatistic = {
  constructionSite: ConstructionSite;
  statistic: ConstructionSiteUsageStatistic;
};